<template>
  <div class="menu">
    <nav>
      <router-link :to="{ name: 'Partners'}" class="nav-item">Отчеты</router-link>
      <!--<router-link :to="{ name: 'ReportPartnerSales'}" class="nav-item">Отчеты</router-link>-->
    </nav>
  </div>
</template>
<script>
export default {
  name: 'Menu'
}
</script>

<style lang="scss" scoped>
.menu {
  display: block;
  min-height: 100vh;
  width: 150px;
  padding: 25px;
  border-right: 1px solid #ccc;
  position: sticky;
  background-color: #f5f5f5;

  a {
    color: #333;
  }

  a:hover {
    color: #666;
    text-decoration: none;
  }
}

nav {
  display: flex;
  flex-wrap: wrap;

  .nav-item {
    margin: 10px 0;
  }

  .router-link-active {
    font-weight: bold;
  }
}
</style>
